export const GET_REMOTE_CONFIG_REQUEST = 'GET_REMOTE_CONFIG_REQUEST';
export const GET_REMOTE_CONFIG_SUCCESS = 'GET_REMOTE_CONFIG_SUCCESS';
export const GET_REMOTE_CONFIG_FAILURE = 'GET_REMOTE_CONFIG_FAILURE';
